import { UpdateNoticeSummaryDTO } from "./UpdateNoticeSummaryDTO";

export class UpdateNoticeDetailsDTO extends UpdateNoticeSummaryDTO {
  description?: string | null;
  userName?: string | null;
  lastEditedDate?: Date | null;
  dueDate?: Date | null;
  timeSliceId?: any;
  fileNames: string[] = [];
  timezone?: string | null;

  constructor(options: Partial<UpdateNoticeDetailsDTO> = {}) {
    super(options); // pass common fields to Summary DTO

    this.description = options.description ?? null;
    this.userName = options.userName ?? null;
    this.lastEditedDate = options.lastEditedDate ?? null;
    this.dueDate = options.dueDate ?? null;
    this.timeSliceId = options.timeSliceId ?? null;
    this.fileNames = options.fileNames ?? [];
    this.timezone = options.timezone ?? null;
  }

  /**
   * Static parse() method for forms / API mapping (same pattern as Summary DTO)
   */
  static parse(data: Partial<UpdateNoticeDetailsDTO>): UpdateNoticeDetailsDTO {
    const parsed = new UpdateNoticeDetailsDTO();

    // Let parent parse first
    const summaryParsed = UpdateNoticeSummaryDTO.parse(data);
    Object.assign(parsed, summaryParsed);

    // Parse additional fields
    parsed.description = data.description ?? null;
    parsed.userName = data.userName ?? null;
    parsed.lastEditedDate = data.lastEditedDate ?? null;
    parsed.dueDate = data.dueDate ?? null;
    parsed.timeSliceId = data.timeSliceId ?? null;
    parsed.fileNames = data.fileNames ?? [];
    parsed.timezone = data.timezone ?? parsed.timezone ?? null;

    return parsed;
  }
}
